export default __webpack_public_path__ + "static/media/Asset-73.4664dd3f.png";